<div>
    <mat-form-field appearance="outline">
        <span matPrefix><mat-icon>search</mat-icon></span>
        <input matInput #searchInput placeholder="Search" (input)="search(searchInput.value)">
        <span matSuffix>
            <button mat-icon-button class="clear-button" *ngIf="searchInput.value !== '' && !isSearching" (click)="searchInput.value = ''; search('')"><mat-icon>clear</mat-icon></button>
            <span *ngIf="isSearching" class="spinner-container"><mat-spinner diameter="20"></mat-spinner></span>
        </span>
    </mat-form-field>
</div>